import axios from 'axios';
import _ from 'lodash';

import { ApiResponse, tryCatcher } from '../utils/error-utils';

function getRquestPayload<Data>(data: Data, action?: string) {
  const params = new URLSearchParams();
  if (action) params.append('action', action);
  if (data) {
    Object.keys(data).forEach(key => {
      if (_.isArray(data[key])) {
        data[key].forEach((value: any, index: number) => {
          params.append(`${key}[${index}]`, value);
        });
      } else {
        params.append(key, data[key]);
      }
    });
  }

  return params;
}

export function getAdminRoute<ReturnType>(action: string): () => Promise<ApiResponse<ReturnType>>;
export function getAdminRoute<ReturnType, DataType>(
  action: string,
): (data: DataType) => Promise<ApiResponse<ReturnType>>;
export function getAdminRoute(action: string) {
  return async (data?: object) => {
    return tryCatcher(async () => {
      const payload = getRquestPayload(data, action);

      const res = await axios.post(globalThis.adminAjaxUrl, payload);

      return res?.data;
    });
  };
}

export function getWcRoute<ReturnType>(action: string): () => Promise<ApiResponse<ReturnType>>;
export function getWcRoute<ReturnType, DataType>(
  action: string,
): (data: DataType) => Promise<ApiResponse<ReturnType>>;
export function getWcRoute(action: string) {
  return async (data?: object) => {
    return tryCatcher(async () => {
      const endpoint = `${globalThis.wcAjaxEndpoint}=${action}`;
      const payload = getRquestPayload(data, action);

      const res = await axios.post(endpoint, payload);

      if (!res.data) {
        throw new Error('Woocommerce error');
      }

      return res.data;
    });
  };
}

export default { getAdminRoute, getWcRoute };
